<template>
  <AppCard class="px-0 pt-0" tile>
    <v-form ref="searchForm" style="margintop: 5px">
      <AppRow class="BG2 px-5 py-2" style="margin: 0 !important">
        <AppColumn class="d-flex pl-0 justify-start">
          جستجوی پیشرفته
        </AppColumn>
      </AppRow>
      <div style="max-height: 450px; overflow-x: hidden; overflow-y: auto">
        <AppRow class="mx-2 py-6" :id="def.id">
          <AppColumn
            v-for="prop in def.searchParam.properties.filter(
              (p) => p.isParamProp || !('isParamProp' in p),
            )"
            :key="prop.id"
            :id="prop.id"
            :cols="def.searchParam.properties.length > 1 && 6"
            :sm="def.searchParam.properties.length > 1 && 12"
            :md="def.searchParam.properties.length > 1 && 6"
            style="paddingtop: 8px; paddingbottom: 0px"
          >
            <AbrSearchProp
              dense
              :def="{
                searchParam: { advancedSearch: def, ...def.searchParam },
                ...prop,
              }"
              :query-model="model.advancedSearch.query"
              :model="Model.advancedSearch.query[prop.name]"
            ></AbrSearchProp>
          </AppColumn>
        </AppRow>
        <AppRow class="my-3 mr-5 mt-8">
          <AbrPrioritySearch
            :model="Model.advancedSearch.orderBy"
            :def="def"
          ></AbrPrioritySearch>
        </AppRow>
      </div>
      <AppRow class="BG2" style="margin: 0 !important">
        <AppColumn class="d-flex pl-0 justify-start">
          <v-btn class="P1 BG1--text" depressed @click="search"> جستجو </v-btn>
          <v-btn text @click="reset"> پاک کردن فیلترها </v-btn>
        </AppColumn>
        <AppColumn>
          <div class="d-flex flex-row justify-md-end align-center">
            <AbrAdvanceSearchExportResult @formatType="exportDataToExcel" />
            <AbrQueryNumber
              class="mx-5"
              :model="Model.advancedSearch"
            ></AbrQueryNumber>
          </div>
        </AppColumn>
      </AppRow>
    </v-form>
  </AppCard>
</template>

<script>
import AbrSearchProp from "@/components/search/AbrSearchProp";
import AppRow from "@/components/library/container/AppRow";
import AppColumn from "@/components/library/container/AppColumn";
import AbrPrioritySearch from "@/components/search/AbrPrioritySearch";
import AbrQueryNumber from "@/components/search/AbrQueryNumber";
import AbrAdvanceSearchExportResult from "@/components/search/AbrAdvanceSearchExportResult";
import {
  advancedSearch,
  advancedSearchToExcelCSV,
  advancedSearchToExcelXLSX,
} from "@/apis";
import AppCard from "@/components/library/container/AppCard";
import downloadCSVFile, { downloadXlsxFile } from "@/utils/downloadFile";

export default {
  name: "AbrAdvancedSearch",
  components: {
    AppCard,
    AbrPrioritySearch,
    AppColumn,
    AppRow,
    AbrSearchProp,
    AbrQueryNumber,
    AbrAdvanceSearchExportResult,
  },
  props: ["def", "model"],
  data: (vm) => ({
    inputs: [],
    Model: vm.model,
  }),
  created() {
    this.Model.advancedSearch.numRows = 10;
    this.Model.advancedSearch.query =
      this.def.searchConfig.advancedSearch.searchParam.properties
        .filter((p) => p.isResultProp || p.isParamProp === undefined)
        .reduce(
          (o, p) => ({ [p.name]: { condition: p.defaultCondition }, ...o }),
          {},
        );

    this.$eventBus.$on("addSearchProp", (prop) => {
      this.inputs.push(prop);
    });
  },
  beforeDestroy() {
    this.$eventBus.$off("addSearchProp");
  },
  methods: {
    async validate() {
      return (
        await Promise.all(
          this.inputs.map(async (i) => await i.validate(i.model?.value)),
        )
      ).every((i) => i);
    },
    reset() {
      this.def.searchParam.properties
        .filter((p) => !p.visible)
        .map(
          (sp) =>
            sp.name in this.Model.advancedSearch.query &&
            this.$set(this.Model.advancedSearch.query, sp.name, {
              condition: this.Model.advancedSearch.query[sp.name].condition,
            }),
        );
    },
    query(){
      return Object.keys(this.Model.advancedSearch.query)
        .filter((k) => {
          const item = this.Model.advancedSearch.query[k];

          return (
            item.condition === "ISNULL" ||
            item.condition === "NOTNULL" ||
            (item.value !== undefined && item.value !== "Invalid date")
          );
        })
        .reduce((o, k) => {
          const item = this.Model.advancedSearch.query[k];

          return {
            ...o,
            [k]: {
              ...item,
              condition:
                item.condition === "ISNULL"
                  ? "EQ"
                  : item.condition === "NOTNULL"
                  ? "NEQ"
                  : item.condition,
              value: ["ISNULL", "NOTNULL"].includes(item.condition)
                ? null
                : item.value,
            },
          };
        }, {});

    },
    async search() {
      if (!(await this.validate())) return;
      this.Model.openAS = false;
      this.Model.showGrid = true;
      const query = this.query();
      // const query = Object.keys(this.Model.advancedSearch.query)
      //   .filter((k) => {
      //     const item = this.Model.advancedSearch.query[k];

      //     return (
      //       item.condition === "ISNULL" ||
      //       item.condition === "NOTNULL" ||
      //       (item.value !== undefined && item.value !== "Invalid date")
      //     );
      //   })
      //   .reduce((o, k) => {
      //     const item = this.Model.advancedSearch.query[k];

      //     return {
      //       ...o,
      //       [k]: {
      //         ...item,
      //         condition:
      //           item.condition === "ISNULL"
      //             ? "EQ"
      //             : item.condition === "NOTNULL"
      //             ? "NEQ"
      //             : item.condition,
      //         value: ["ISNULL", "NOTNULL"].includes(item.condition)
      //           ? null
      //           : item.value,
      //       },
      //     };
      //   }, {});
      const orderBy = this.Model.advancedSearch.orderBy
        .filter((o) => o.property)
        .map((o) =>
          Object.assign(
            { property: o.property },
            o.descending != null ? { descending: o.descending } : {},
          ),
        );
      const version = "latest";
      const numRows = this.model.advancedSearch.numRows;
      this.Model.loading = true;
      try {
        const res = await advancedSearch(this.def.searchConfig.id, {
          query: {
            ...query,
            version,
            numRows,
          },
          orderBy,
        });
        this.model.result.splice(0);
        res.forEach((item, index) => this.$set(this.model.result, index, item));
        // this.Model.result = await advancedSearch(this.def.searchConfig.id, {query: {
        //   ...query,
        //   version
        // }, orderBy });
      } finally {
        this.Model.loading = false;
      }
    },
    async exportDataToExcel(formatType) {
      // const numRows = null;
      const numRows = this.model.advancedSearch.numRows;
      const query = this.query();
      // const query = Object.keys(this.Model.advancedSearch.query)
      //   .filter(
      //     (k) =>
      //       this.Model.advancedSearch.query[k].value !== undefined &&
      //       this.Model.advancedSearch.query[k].value !== "Invalid date",
      //   )
      //   .reduce(
      //     (o, k) => ({ [k]: this.Model.advancedSearch.query[k], ...o }),
      //     {},
      //   );
      const orderBy = this.Model.advancedSearch.orderBy
        .filter((o) => o.property)
        .map((o) =>
          Object.assign(
            { property: o.property },
            o.descending != null ? { descending: o.descending } : {},
          ),
        );
      const version = "latest";
      const params = { query: { ...query, version, numRows }, orderBy };

      if (formatType === "xlsx") {
        advancedSearchToExcelXLSX(this.def.searchConfig.id, params).then(
          (xlsxData) => {
            downloadXlsxFile(
              xlsxData,
              "ReportMainAgencyExcel.xlsx",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
            );
          },
        );
      } else if (formatType === "csv") {
        const csvData = await advancedSearchToExcelCSV(
          this.def.searchConfig.id,
          params,
        );

        downloadCSVFile(csvData, `${this.def.searchConfig.id}.csv`);
      }
    },
  },
};
</script>
